import axios from 'axios';

// Prefer explicit env; fallback to localhost:4000 in dev to avoid hitting the CRA dev server
const computedBaseURL = process.env.REACT_APP_API_URL || (
  typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost'
    ? 'http://localhost:4000/api'
    : '/api'
);

const api = axios.create({
  baseURL: computedBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // For FormData (file uploads), don't set Content-Type header
    // Let the browser set it with the proper boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Don't auto-redirect on logout endpoint - let logout function handle it
    const isLogoutRequest = error.config?.url?.includes('/auth/logout');

    if (error.response && error.response.status === 401 && !isLogoutRequest) {
      // Clear stored token and user data
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');

      // Show session expired message and redirect to login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login?message=session_expired';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
